import { type FC } from "react";

import classNames from "classnames";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { Card } from "@jti/core-components/components/Card";
import { Loader } from "@jti/core-components/components/Loader";
import { Controller, useFormContext, useTranslations } from "@jti/ui";

import { DeliveryOptionsList } from "./components/DeliveryOption";

import type { DeliveryOptionsFieldConfig } from "./DeliveryOptionsField.types";

import styles from "./DeliveryOptionsField.module.scss";

export type DeliveryOptionsFieldProps = {
  fieldConfig: DeliveryOptionsFieldConfig;
};

export const DeliveryOptionsField: FC<DeliveryOptionsFieldProps> = ({ fieldConfig }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { __ } = useTranslations();

  const { name, options, selectionDisabled, isSubscription, onChange, registerOptions, isLoading } = fieldConfig;
  const fieldError = errors[name];

  return (
    <div className={classNames({ [styles.disabled]: selectionDisabled })} data-testid="delivery-options-card">
      <Card title={__("cart.checkout.shipping_options.title")}>
        {isLoading ? (
          <Loader />
        ) : (
          <div className={styles.cardContent}>
            {fieldError && <AlertBanner tone="error" description={fieldError.message as string} />}
            <Controller
              control={control}
              name={name}
              rules={registerOptions}
              render={({ field }) => (
                <DeliveryOptionsList
                  {...field}
                  selectionDisabled={selectionDisabled}
                  isSubscription={isSubscription}
                  options={options}
                  onChange={(e) => {
                    const deliveryOption = e.target.value;
                    field.onChange(deliveryOption);
                    onChange?.(deliveryOption);
                  }}
                />
              )}
            />
          </div>
        )}
      </Card>
    </div>
  );
};
